import React from 'react'

import PerfectScrollbar from 'react-perfect-scrollbar'
import PropTypes from 'prop-types'
import { isNil } from 'lodash'
import { Box, Grid, TablePagination, useMediaQuery } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

import { BulkSelectionAllCheckbox } from 'components'
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from 'components/Table'
import { Row, UsersBulkActions } from './components'

import theme from 'theme'
import useStyles from './styles'

const UsersTable = ({
  userCompanies,
  isLoading,
  profiles,
  refresh,
  count,
  pagination = {},
}) => {
  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    pagination

  const classes = useStyles()

  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })

  return (
    <>
      <UsersBulkActions profiles={profiles} refresh={refresh} />

      <Box display="flex" width="100%" mt={2}>
        <Grid container>
          <Box width="100%">
            <PerfectScrollbar>
              <Table
                size="medium"
                emptyMessage="Nenhum usuário encontrado"
                isLoading={isLoading}
                noWrap
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      padding="checkbox"
                      className={classes.checkboxCell}
                    >
                      <BulkSelectionAllCheckbox label="Selecionar todos os usuários" />
                    </TableCell>
                    <TableCell width="20%">Identificador</TableCell>
                    <TableCell width="30%">Usuário</TableCell>
                    <TableCell width="10%">Status</TableCell>
                    <TableCell width="20%">Perfil</TableCell>
                    <TableCell width="10%">Criado em</TableCell>
                    <TableCell width="10%" align="right">
                      Ações
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody skeletonRows={perPage}>
                  {userCompanies?.map((userCompany) => (
                    <Row
                      key={userCompany.id}
                      userCompany={userCompany}
                      refresh={refresh}
                      profiles={profiles}
                    />
                  ))}
                </TableBody>
              </Table>
            </PerfectScrollbar>
          </Box>
        </Grid>
      </Box>

      <Box px={2} display="flex" justifyContent="flex-end">
        {!isLoading && !isNil(count) ? (
          <TablePagination
            component="div"
            count={count}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            page={page - 1}
            rowsPerPage={perPage}
            rowsPerPageOptions={[5, 10, 25, 50]}
            labelRowsPerPage={isDesktop ? 'Por página' : ''}
            nextIconButtonProps={{ size: 'small' }}
            backIconButtonProps={{ size: 'small' }}
          />
        ) : (
          <Box py="11px">
            <Skeleton variant="rect" width={200} height={30} />
          </Box>
        )}
      </Box>
    </>
  )
}

UsersTable.propTypes = {
  userCompanies: PropTypes.array,
  refresh: PropTypes.func,
  isLoading: PropTypes.bool,
  profiles: PropTypes.array,
  count: PropTypes.number,
  pagination: PropTypes.object,
}

UsersTable.defaultProps = {
  refresh: () => {},
}

export default UsersTable
